import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { refreshLead } from 'bundles/project/actions/leads';

import { showUpdateLeadModal } from '../../../actions';
import { Button } from 'react-bootstrap-5';

export class EditContactLink extends React.Component {
  static propTypes = {
    lead: PropTypes.shape({
      id: PropTypes.number.isRequired,
      projectId: PropTypes.number.isRequired
    }).isRequired,
    onOpenBrokeTeamExpirienceLeadModal: PropTypes.func,
    onRefreshLead: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  state = {
    editing: false
  };

  handleCancel = () => {
    this.setState({ editing: false });
  }

  handleSave = () => {
    this.setState({ editing: false });
    this.props.onRefreshLead(this.props.lead);
  }

  startEdit = (e) => {
    this.props.onOpenBrokeTeamExpirienceLeadModal(this.props.lead);
  };

  render() {
    return (
      <React.Fragment>
        { this.renderNewLink() }
      </React.Fragment>
    );
  }

  renderNewLink() {
    return (
      <Button name="edit-lead-button" variant="secondary" onClick={this.startEdit}>
        Edit Lead Info
      </Button>
    );
  }
}

const mapDispatchToProps = {
  onRefreshLead: refreshLead,
  onOpenBrokeTeamExpirienceLeadModal: showUpdateLeadModal
};

export default connect(null, mapDispatchToProps)(EditContactLink);
